export enum adminConstants {
  GET_ADMINS = 'GET_ADMINS',
  GET_ADMIN = 'GET_ADMIN',
  ADD_ADMIN = 'ADD_ADMIN',
  EDIT_ADMIN = 'EDIT_ADMIN',
  DELETE_ADMIN = 'DELETE_ADMIN',
  REGENERATE_ADMIN_PASSWORD = 'REGENERATE_ADMIN_PASSWORD',
}
